import React from 'react';
import Icon from '../../../icon';

interface SectionHeaderProps {
  icon: string;
  title: string;
  showQRCode?: boolean;
  qrText?: string;
  className?: string;
}

export function SectionHeader({
  icon,
  title,
  showQRCode = false,
  qrText = 'Bekijk mijn Slip profiel',
  className = '',
}: SectionHeaderProps) {
  return (
    <div
      className={`flex justify-between items-center pt-8 break-after-avoid ${className}`}>
      <div className="flex items-center gap-2">
        <Icon
          name={icon}
          className="text-primary flex justify-center items-center"
          size="large"
        />
        <h2 className="text-2xl font-extrabold leading-tight text-gray-800">
          {title}
        </h2>
      </div>
      {showQRCode && (
        <div className="bg-primary rounded-full px-3 py-1 flex items-center gap-1">
          <Icon name="qr-code-outline" className="w-4 h-4 text-white" />
          <span className="text-md font-normal leading-tight text-white">
            {qrText}
          </span>
        </div>
      )}
    </div>
  );
}
